<template>
  <div class="networks-card desktop-shadow-card desktop-white-bg rounded">
    <div class="card-header">
      <h4 class="card-header-title">
        <icon type="project-diagram" class="mr-2" /> My Network
        <i
          class="fa fa-info-circle cursor-pointer ml-2 tooltip-info"
          v-tooltip="'Your network requests approved by vendors'"
        ></i>
      </h4>
      <div class="d-flex justify-content-end my-3 my-md-0">
        <div class="d-flex align-items-center text-dark">
          <span>
            <b v-if="!loading">
              <i class="fas fa-spin fa-circle-notch" v-if="busy"></i>
              {{ busy ? "" : networks.length }}/{{ total }}</b
            >
            <i class="fas fa-spin fa-circle-notch" v-if="loading"></i>
            Connection{{ loading || total != 1 ? "s" : "" }}
          </span>
        </div>
      </div>
    </div>
    <alert
      v-if="!networks.length && !loading"
      class="my-4 mx-lg-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
      >No Connections to display</alert
    >
    <alert
      v-if="loading"
      type="loader"
      color="light"
      class="my-4 mx-lg-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
    />
    <div v-if="!loading && networks.length" class="px-lg-4 pt-lg-4">
      <div
        class="col-12 card p-3 mobile-tablet-shadow-card"
        v-for="network of networks"
        :key="network.id"
      >
        <div
          class="row vendor-info-row mt-3 justify-content-center relative-position"
        >
          <div class="col-4 col-md vendor-logo-col">
            <img
              :src="network.logoUrl || '/images/no-logo.png'"
              class="rounded-circle w-100"
            />
          </div>
          <div class="col-12 col-md-10 mt-4">
            <h1 class="header-title bold text-capitalize">
              {{ network.name }}
            </h1>
            <p class="text-dark mt-2 bio-text">
              <icon class="mr-3" type="align-left" />
              {{ network.bio || "Bio not available." }}
            </p>
          </div>
          <div class="vendor-avatar">
            <img
              :src="`/images/map-avatars/${network.avatar_type || 0}.png`"
              class="avatar-img shadow-card m-0 cursor-pointer border-0"
              v-tooltip.top="vendorAvatars[network.avatar_type || 0].tooltip"
            />
          </div>
        </div>
      </div>
    </div>
    <mugen-scroll :handler="loadMore" :should-handle="!busy && !loading">
      <alert
        v-if="busy"
        class="text-center p-2 mb-0 mobile-tablet-loadmore mobile-tablet-shadow-card"
        ><i class="fas fa-spin fa-circle-notch mr-2"></i>Loading more
        connections...</alert
      >
    </mugen-scroll>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MugenScroll from "vue-mugen-scroll";
import constants from "../constants";

export default {
  name: "myNetworks",
  components: {
    MugenScroll,
  },
  data() {
    return {
      limit: 50,
      busy: false,
      vendorAvatars: constants.AVATARS,
    };
  },
  computed: {
    ...mapState(["vendors"]),
    ...mapState({
      networks: (state) => state.networks.pagination.data,
      current: (state) => state.networks.pagination.current,
      total: (state) => state.networks.pagination.total || 0,
      loading: (state) => state.networks.loading,
    }),
    vendor: function () {
      return this.vendors.single;
    },
  },
  mounted() {
    if (!this.vendor) {
      this.$store.dispatch("vendors/get", { id: this.$route.params.id });
    }
    this.getNetworks();
  },
  methods: {
    ...mapActions({
      getVendorNetworks: "networks/get",
    }),
    getNetworks(page) {
      const payload = {
        limit: this.limit,
        id: this.$route.params.id,
      };
      if (page) {
        payload.page = page;
      }
      this.getVendorNetworks(payload).then(() => {
        this.busy = false;
      });
    },
    loadMore() {
      if (this.networks.length < this.total) {
        this.busy = true;
        this.getNetworks(this.current + 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.vendor-logo-col {
  max-width: 130px !important;
}

.vendor-avatar {
  position: absolute;
  right: 16px;
  top: -8px;
  .avatar-img {
    width: 56px;
    max-height: 56px;
    border-radius: 50%;
  }
}

@media (max-width: 1024px) {
  .networks-card {
    .card-header {
      padding: 0 !important;
    }
  }
}

@media (max-width: 767px) {
  .networks-card {
    .card-header {
      display: block;
      height: auto;
    }
  }
}
</style>
